/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react';

interface propsInterface {
  currentColor: {
    gradation: string[] | null,
    hex: string | null,
    rgb: string | null
  },
  scaleType: string
}

export const CopyButton = React.memo<propsInterface>((props) => {
  const copyCode = (event: any) => {
    const 
      source = props.scaleType === 'step' ? `${props.currentColor.hex} / ${props.currentColor.rgb}` : `linear-gradient(90deg,${props.currentColor.gradation});`,
      alertMessage = props.scaleType === 'step' ? 'HEX & RGB Code Copied!!' : 'CSS Property Value Copied!!',
      listener = (event: any) => {
        event.clipboardData.setData('text/plain' , source);
        event.preventDefault();
        document.removeEventListener('copy', listener);
      };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    alert(alertMessage);
  };
  return (
    <>
      <button className='p-copy-button __button' onClick={copyCode}>
        <span className='__text'>copy!</span>
      </button>
    </>
  )
});